module.exports = __webpack_public_path__ + "static/2-464aa83a17367138edaa77b7da7cdec6.png";